module.exports = __webpack_public_path__ + "img/dots_silver.4d581589.png";